const enums = {
  activityTypes: { CREATED: 1, ADDED: 2, REMOVED: 3, SENT: 4, FINISHED: 5 },
  businessMetricUnitTypes: {
    CURRENCY: 1,
    PERCENTAGE: 2,
    COUNT: 3
  },
  companyPlanTypes: {
    SETUP: 1,
    ENGAGEMENT: 2,
    LITE: 4
  },
  coreCardIdTypes: {
    MEMBER: 1,
    TEAM: 2,
    MANAGER: 3,
    CORE_VALUE: 4,
    COMPANY: 5
  },
  coreCardTypes: {
    OVERALL: 1,
    ENGAGEMENT: 3,
    REVIEW: 4,
    RECOGNITION: 5,
    GOAL: 6,
    ACTION_ITEM: 7,
    MANAGER_SCORE: 8,
    MISSION_VALUE: 9,
    ENPS: 10,
    PULSE: 11,
    TEAM_COHESION: 12,
    IDEAL_TEAM_PLAYER: 13,
    STRATEGIC_ANCHORS: 14,
    ANONYMOUS_FEEDBACK: 15,
    HIGH_LOW: 16
  },
  customFieldTypes: {
    TEXT: 1,
    DATE: 2,
    LARGE_TEXT: 3
  },
  features: {
    PULSE: 1,
    SURVEYS: 2,
    RESOURCE: 3,
    REVIEW: 4,
    CHECK_INS: 5,
    RECOGNITION: 6,
    GOALS: 7,
    ANNUAL_REVIEWS: 8
  },
  frequency: {
    WEEKLY: 1,
    MONTHLY: 2,
    QUARTERLY: 3,
    BI_WEEKLY: 4,
    ANNUAL: 5
  },
  goalStatusTypes: {
    ON_TRACK: 1,
    OFF_TRACK: 2,
    PAUSED: 3,
    COMPLETED: 4
  },
  insightCategories: {
    ALERT: 1,
    CELEBRATE: 2,
    WATCH: 3
  },
  insightChangeTypes: {
    VALUE: 1,
    PERCENTAGE: 2
  },
  insightTargets: {
    COMPANY: 1,
    DEPARTMENTS: 2,
    MEMBERS: 3
  },
  integrations: { SLACK: 1 },
  linkTypes: {
    MEMBERS: 1,
    MANAGERS: 2,
    SURVEY: 3,
    RESOURCE: 4,
    DEPARTMENTS: 5,
    REVIEW: 6,
    ANNUAL_REVIEW: 7,
    COMPANY: 8,
    FEATURE: 9,
    PULSE: 10,
    RECOGNITION: 11,
    BILLING: 12,
    FEEDBACK: 13,
    GOAL: 14,
    CHECK_IN: 15,
    PROFILE: 16,
    ACTION_ITEM: 17
  },
  notifications: {
    PULSE: 1,
    SURVEY: 2,
    RESOURCE: 3,
    TASK_REMINDER: 4,
    RECOGNITION: 5,
    EMPLOYEE_RECOGNITION: 6,
    URGENT_TALKING_POINT: 7,
    FEEDBACK_ACKNOWLEDGED: 8,
    FEEDBACK_RECEIVED: 9,
    MEETING_STARTED: 10,
    MEETING_ENDED: 11
  },
  questionTypes: {
    CORE_SCORE: 0,
    OPINION_SCALE: 1,
    TEXT_RESPONSE: 2,
    MULTIPLE_CHOICE: 3
  },
  pulseRelatedItemTypes: {
    SUB_CATEGORY: 1,
    CORE_VALUE: 2
  },
  systemRoleTypes: {
    ADMIN: 3,
    MEMBER: 4,
    MANAGER: 5
  },
  taskTypes: {
    FEEDBACK_TO_ACKNOWLEDGE: 1,
    SURVEY_TO_TAKE: 4,
    RESOURCE_TO_READ: 5,
    PULSE_TO_ANSWER: 9,
    ANNUAL_REVIEW_AVAILABLE: 13,
    ANNUAL_REVIEW_SIGNOFF_READY: 14,
    CHECK_IN_STARTED_BUT_NOT_FINISHED: 23,
    REVIEWS_AVAILABLE: 24,
    ANNUAL_REVIEW_HR_SIGNOFF_NEEDED: 34
  },
  timeframes: {
    LAST_90_DAYS: 1,
    LAST_6_MONTHS: 2,
    LAST_12_MONTHS: 3,
    ALL_TIME: 4,
    CUSTOM: 5,
    LAST_30_DAYS: 6
  },
  userStatuses: {
    ADDED: 1,
    ACTIVE: 2,
    INACTIVE: 3,
    DEACTIVATED: 4,
    PAUSED: 5
  },
  resourceStatuses: {
    SCHEDULED: "scheduled",
    SENT: "sent",
    READY: "ready"
  }
};

export default enums;
